import api from '../Token';

export const AlterPassword = async (dados) => {
  try {
    const response = await api.post('/updatePassword', dados);

    // 🔥 retorna exatamente o que o backend devolveu
    return response.data;

  } catch (error) {
    if (error.response && error.response.data) {
      // 🔥 retorna exatamente o erro do backend
      throw error.response.data;
    }

    // erro de rede/servidor sem resposta
    throw {
      message: 'Erro de conexão com o servidor.',
    };
  }
};